<form [formGroup]="selectAccountsForm">
    <mat-form-field appearance="outline" rsControlErrors>
        <mat-label>{{ label }}</mat-label>
        <mat-select [(value)]="account" required formControlName="account">
            <mat-select-trigger class="flex-row-start-center">
                <app-system-icon class="system-icon-select-account-one"
                    systemId="{{account && account.relationships.system.data ? account.relationships.system.data.attributes.group_id : ''}}">
                </app-system-icon>
                <p data-cy="value-select-account">{{ account ? account.attributes.address : '' }}</p>
            </mat-select-trigger>
            <mat-option class="add-account-option" (click)="openDialog()">
                <span class="material-icons-outlined">add</span>
                Agregar cuenta {{filteredAccounts.length === 0 && filterName ? 'de ' + filterName : ''}}
            </mat-option>
            <mat-option *ngIf="showSkeleton">
                <ng-container *ngTemplateOutlet="skeletonSelectAccount"></ng-container>
            </mat-option>
            <mat-option data-cy="account-option" *ngFor="let account of filteredAccounts; trackBy:trackByAccount" [value]="account">
                <app-system-icon
                    alt="{{account.relationships.system.data ? account.relationships.system.data.attributes.name : ''}}"
                    class="system-icon-select-account-two"
                    systemId="{{account.relationships.system.data ? account.relationships.system.data.attributes.group_id : ''}}">
                </app-system-icon>
                {{ account.attributes.address}} <span class="name-account" *ngIf="account.attributes.alias">({{account.attributes.alias}})</span>
            </mat-option>
        </mat-select>
    </mat-form-field>
</form>

<ng-template #skeletonSelectAccount>
    <div class="skeleton-space">
       <app-skeleton></app-skeleton>
       <app-skeleton></app-skeleton>
       <app-skeleton></app-skeleton>
    </div>
</ng-template>
